import { render, staticRenderFns } from "./H5OrderDetail.vue?vue&type=template&id=552708cd&scoped=true"
import script from "./H5OrderDetail.vue?vue&type=script&lang=js"
export * from "./H5OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./H5OrderDetail.vue?vue&type=style&index=0&id=552708cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552708cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552708cd')) {
      api.createRecord('552708cd', component.options)
    } else {
      api.reload('552708cd', component.options)
    }
    module.hot.accept("./H5OrderDetail.vue?vue&type=template&id=552708cd&scoped=true", function () {
      api.rerender('552708cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5OrderDetail.vue"
export default component.exports